var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":['Home','VouchersSearch']}},[_c('router-view')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }